import React from "react";
import { TableStake } from "./TableStake";

export const TabEarn = ({ data }) => {
  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] xls:gap-[60px] mt-[10px] lg:mt-[24px] xls:mt-[44px]">
      <TableStake />
    </div>
  );
};
